// extracted by mini-css-extract-plugin
export default {"container":"answer_container__UITzf","subtotal":"answer_subtotal__7E4Gc","observation":"answer_observation__22wuR","actions":"answer_actions__iHFZ9"};